import { render, staticRenderFns } from "./RequestDialog.vue?vue&type=template&id=10823f8c"
import script from "./RequestDialog.vue?vue&type=script&lang=js"
export * from "./RequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports